var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightBlue1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 365,
    viewBox: "0 0 215 365",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.527 364.126C146.187 352.438 74.8624 342.548 1.39182 334.681V54.8416C74.8624 40.4563 146.187 22.2499 213.527 0.784302V364.126Z",
    fill: "#00C8D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.016 1.5711V363.452C145.983 351.876 74.9645 341.986 1.9027 334.232V55.2913C74.9645 40.906 145.983 22.9243 213.016 1.5711ZM214.037 0.110107C146.8 21.5757 75.4754 39.7821 0.880859 54.3922V335.131C75.4754 343.11 146.698 353 214.037 364.688V0.110107Z",
    fill: "#00C8D5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBlue1);
export default __webpack_public_path__ + "static/media/RightBlue1.17d3dc920139362d9f3f752217439312.svg";
export { ForwardRef as ReactComponent };